import dynamic from "next/dynamic";
const App = dynamic(() => import("../components/App"));
import React, { useState } from "react";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import axios from "axios";
import {
  Breadcrumb,
  Spin,
  Row,
  Col,
  Space,
  Form,
  Input,
  Button,
  notification,
  message,
  Radio,
} from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Api } from "../networks/Api";
import ReactPlayer from "react-player";

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const { t } = useTranslation("common");
  const [shoppingFrom] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [appChat, setAppChat] = useState("");
  const router = useRouter();
  const { locale } = router;
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const openNotificationError = (msg) => {
    notification.open({
      message: "Notice",
      description: msg,
      placement: "top",
    });
  };

  const onFinish = async (values) => {
    setLoading(true);
    const url = `${Api.createPersonalshopping}`;
    const postData = {
      name: values?.name,
      email: values?.email,
      item_name: values?.item_name,
      link: values?.link || "",
      color: values?.color || "",
      size: values?.size || "",
      chat_app: appChat || "",
      chat_name: values?.chat_name || "",
    };
    try {
      const response = await axios.post(url, postData, Api.Header());
      if (response.status == 200) {
        notification.open({
          message: `${t("success-title")}`,
          description: `${t("success-text")}`,
          placement: "top",
        });
        shoppingFrom.setFieldsValue({
          name: "",
          email: "",
          item_name: "",
          link: "",
          color: "",
          size: "",
          chat_name: "",
        });
        setAppChat("");
        setLoading(false);
        return;
      } else {
        setLoading(false);
        openNotificationError(response.data.message);
        return;
      }
    } catch (e) {
      console.log("contact >> createPersonalshopping error :", e);
      // AlertError('Something went wrong.')
      openNotificationError(e?.message);
      setLoading(false);
    }
  };

  const onFinishFailed = (e) => {
    console.log(e);
    message.error("Submit failed!");
  };

  const handleChangeApp = (value) => {
    setAppChat(value?.target?.value);
  };

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Personal Shopping</title>
      </Head>
      <Spin spinning={loading}>
        <Row justify="center" style={{ marginBlock: 24 }}>
          <Col xs={22} sm={22} md={22} lg={22} xl={20}>
            <Breadcrumb
              style={{ marginBottm: 24 }}
              items={[
                {
                  key: "home",
                  title: (
                    <Link href={`/${queryParam ? `?${queryParam}` : ``}`}>
                      {t("home")}
                    </Link>
                  ),
                },
                {
                  key: "Personal Shopping",
                  title: `${t("Personal Shopping")}`,
                },
              ]}
            />
            <Row gutter={[12, 24]} justify={`center`} type="flex">
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                xl={12}
                style={{ marginTop: 24 }}
              >
                <Space direction="vertical">
                  <p className="h4">Personal Shopping</p>
                  {locale == "th" ? (
                    <div style={{ lineHeight: "1.5em" }}>
                      <p>
                        หากคุณกำลังมองหาสิ่งที่ไม่มีในเว็บไซต์ของเรา?
                        ตามล่าหาของสะสมในอดีต? เราพร้อมให้บริการทุกวันตลอด 24
                        ชั่วโมง ด้านล่างนี้เราได้ระบุวิธีที่เราสามารถช่วยได้
                        ให้ทีมผู้เชี่ยวชาญของเราทำงานอย่างหนักเพื่อคุณ
                        <p className="h3" style={{ marginBlock: "24px" }}>
                          วิธีการทำงาน
                        </p>
                        <div>
                          1.
                          กรอกแบบฟอร์มของเราและให้ข้อมูลมากที่สุดเท่าที่จะเป็นไปได้
                          <br />
                          2. เราจะรับทราบคำขอของคุณภายใน 24 ชั่วโมง
                          (โดยทั่วไปจะเร็วกว่านั้น)
                          <br />
                          3. เราจะอัปเดตคุณในราคา
                          <br />
                          ความพร้อมจำหน่าย และระยะเวลาดำเนินการ
                          <br />
                          4. คุณแจ้งให้เราทราบว่าคุณยินดีที่จะดำเนินการ
                          และทีมผู้เชี่ยวชาญของเราจะทำงานเพื่อจัดหาและจัดส่งสินค้าของคุณไปยังปลายทางที่คุณเลือก
                        </div>
                      </p>
                    </div>
                  ) : (
                    <div style={{ lineHeight: "1.5em" }}>
                      <p>
                        If you are looking for something that is not available
                        on our website? Hunting for collectibles from the past?
                        We are available 24/7. Below we have listed ways we can
                        help. Let our expert team do the hard work for you.
                        <p className="h3" style={{ marginBlock: "24px" }}>
                          How it works
                        </p>
                        <div>
                          1. Fill out our form and provide as much information
                          as possible.
                          <br />
                          2. We will acknowledge your request within 24 hours
                          (usually sooner).
                          <br />
                          3. We will update the price for you. Availability and
                          duration of action
                          <br />
                          {`4. You let us know you're willing to take action. And
                          our expert team will procure and deliver the goods to
                          the destination of your choice.`}
                        </div>
                      </p>
                    </div>
                  )}

                  <Form
                    form={shoppingFrom}
                    name="contact"
                    layout="vertical"
                    onFinish={onFinish}
                    AddressFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Row gutter={[16]}>
                      <Col span={24}>
                        <Form.Item
                          name="name"
                          className="label-require"
                          label={`${t("name")} *`}
                          rules={[
                            {
                              required: true,
                              message: `${t("err-require")}${t("name")}`,
                            },
                            { type: "string" },
                          ]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="email"
                          className="label-require"
                          label={`${t("email")} *`}
                          rules={[
                            {
                              required: true,
                              message: `${t("err-require")}${t("email")}`,
                            },
                            {
                              type: "email",
                              message: `${t("email")}${t("err-email")}`,
                            },
                          ]}
                        >
                          <Input className="input-checkout" size="large" />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="item_name"
                          className="label-require"
                          label={`${t("item-name")} *`}
                          rules={[
                            {
                              required: true,
                              message: `${t("err-require")}${t("item-name")}`,
                            },
                            { type: "string" },
                          ]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="link"
                          className="label-require"
                          label="Link"
                          rules={[{ type: "string" }]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name="color"
                          label={t("color")}
                          rules={[
                            {
                              type: "string",
                            },
                          ]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          name="size"
                          label={t("size")}
                          rules={[
                            {
                              type: "string",
                            },
                          ]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item name="chat_app" style={{ marginBottom: 7 }}>
                          <Radio.Group
                            defaultValue={appChat}
                            onChange={handleChangeApp}
                          >
                            <Radio className="radio-register" value={`line`}>
                              Line ID
                            </Radio>
                            <Radio className="radio-register" value={`phone`}>
                              Phone Number
                            </Radio>
                            <Radio className="radio-register" value={`wechat`}>
                              Wechat
                            </Radio>
                            <Radio
                              className="radio-register"
                              value={`whatsapp`}
                            >
                              WhatsApp
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                        <Form.Item name="chat_name">
                          <Input className="input-login" size="large" />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item>
                          <Space direction="vertical" style={{ width: "100%" }}>
                            <Button
                              className="btn-login"
                              size="large"
                              type="primary"
                              htmlType="submit"
                              block
                            >
                              {t("confirm")}
                            </Button>
                          </Space>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </Space>
              </Col>
              <Col
                xs={22}
                sm={22}
                md={10}
                lg={10}
                xl={10}
                style={{ marginTop: 24 }}
              >
                <div className="player-wrapper">
                  <ReactPlayer
                    url="/static/videos/luxury29-video.mp4"
                    playing={true}
                    loop={true}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </App>
  );
};

export default Home;
